/* eslint-disable no-useless-escape */
import { Modal } from "react-bootstrap";
import { popCancelBttn, imsLoader } from "../../assets";
import { Component } from "react";
import Button from "../Button";
import '../PopUp/GlobalSearchFeaturesPopUp.css'
import './GenAIBookmarkPopUp.css'
import ApiServices from "../../utils/apiServices";
import MobileViewButton from "../Button/MobileViewButton";
import RenameBookmarkPopup from "../PopUp/RenameBookmarkPopUp";
import GenAIRenameBookmarkPopUp from "./GenAIRenameBookmarkPopUp";
import trackingService from "../../services/trackingService";
import { snippetLongString } from "../../utils/utilityServices"
import ConfirmMessagePopUpModal from "./ConfirmMessagePopUpModal"
import moment from 'moment';

class GenAIBookmarkpopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreateBookmark: true,
      isManage: false,
      apiResponse: [],
      bookmarkName: '',
      error: '',
      isContinue: false,
      searchQuery: '',
      showRenamePop: false,
      itemtoBeRenamedName: '',
      itemtoBeRenamedID: '',
      itemtoBeRenamedSearch: '',
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageIndex: -1,
    };
  }
  async componentDidMount() {
    let username = JSON.parse(localStorage.getItem('username')).toLowerCase();
    let service = new ApiServices();
    let apiRes = await service.getBookmarkById(username);
    apiRes = apiRes.sort(function (a, b) { return new Date(b.added_on).getTime() - new Date(a.added_on).getTime() })
    this.setState({
      apiResponse: apiRes,
      searchQuery: window.location.search,
      isLoaded: true
    })
    if (this.props.isfromUserProfile) {
      this.setState({ isCreateBookmark: false, isManage: true })
    }
  }

  showConfirmMessage = (message, index) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageIndex: index
    })
  }

  confirmHandler = async () => {
    const { confirmMessageIndex } = this.state;
    let username = JSON.parse(localStorage.getItem('username')).toLowerCase();
    let bookmarkName = this.state.apiResponse[confirmMessageIndex].bookmark_name;
    let service = new ApiServices();
    await service.deleteBookmark(username, bookmarkName)
    this.setState({
      isLoaded: false,
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    }, async () => {
      let apiRes = await service.getBookmarkById(username);
      apiRes = apiRes.sort(function (a, b) { return new Date(b.added_on).getTime() - new Date(a.added_on).getTime() })
      this.setState({
        apiResponse: apiRes,
        isLoaded: true
      })
    })
  }

  closeAlertMessage = () => {
    this.setState({
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    })
  }
  viewBookmark = (index) => {
    let url;
    if (window.location.pathname === '/ReferencesUsed') {
      url = `${window.location.origin}/ReferencesUsed${this.state.apiResponse[index].search_property}`
      window.open(url, '_blank');
    }
    else {
      url = `${window.location.origin}/results${this.state.apiResponse[index].search_property}&isDisableAiOverview=true`
    }
    // url = `${window.location.origin}/results${this.state.apiResponse[index].search_property}`
    window.open(url, '_blank');
  }
  shareBookmark = (index) => {
    let downloadurl = window.location.pathname === '/ReferencesUsed' ? `/ReferencesUsed${this.state.apiResponse[index].search_property}` : `/results${this.state.apiResponse[index].search_property}`
    let mailUrl = window.location.origin + downloadurl
    let bookmarkName = this.state.apiResponse[index].bookmark_name
    bookmarkName = encodeURIComponent(bookmarkName);
    let mailbody = `Bookmark Name: ${bookmarkName}%0D%0DURL:${mailUrl.replace(/&/g, '\%26').replace(/%20/g, '\+')}%0D%0DTo create your own bookmark, follow these instructions:%0D%0D
    1. Click on the link above to run the bookmark on iMedical Search.%0D 
    2. Click the 'Bookmarks' icon from the search results screen.%0D 
    3. For the Bookmark Name option, enter a name of your choosing for the bookmark.%0D 
    4. Click the Save my bookmark button.%0D%0DTo manage all your bookmarks, access the same 'Bookmarks' icon from a search results screen.  
`
    window.open(`mailto:?Subject=iMS Search - '${bookmarkName}' Bookmark&body=${mailbody}`)
  }
  deleteBookmark = async (index) => {
    this.showConfirmMessage("Are you sure to delete this Bookmark?", index);
  }
  handleInput = (e) => {
    e.target.value = snippetLongString(e.target.value);
    this.setState({
      bookmarkName: e.target.value
    })
  }
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let bookmark = this.state.apiResponse.map(data => data.bookmark_name.toLowerCase())
    if (this.state.bookmarkName.length <= 0 || (this.state.bookmarkName && this.state.bookmarkName.trim().length <= 0)) {
      formIsValid = false;
      errors["bookmarkName"] = 'Please enter a valid name to proceed.';
    }
    if (bookmark.includes(this.state.bookmarkName.toLowerCase())) {
      formIsValid = false;
      errors["bookmarkName"] = `Bookmark Name already exists in your list. Please give a different name other than '${this.state.bookmarkName}'`;
    }
    this.setState({ error: errors });
    return formIsValid;
  }
  onSaveBookmark = async () => {
    let service = new ApiServices();
    let username = JSON.parse(localStorage.getItem('username')).toLowerCase();
    let bookmarkName = this.state.bookmarkName;
    let searchProp = this.state.searchQuery;
    let currentDate = new Date();
    if (this.handleValidation()) {
      this.setState({ isContinue: true })
      await service.createBookmark(username, bookmarkName, searchProp, this.dateFormate(currentDate))
      this.handelAddBookmark();
    }
  }
  dateFormate = (date) => {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`
  }
  handleViewManageBookmark = () => {
    let username = JSON.parse(localStorage.getItem('username')).toLowerCase();
    let service = new ApiServices();
    this.setState({
      isCreateBookmark: false,
      isManage: true,
      isLoaded: false
    }, async () => {
      let apiRes = await service.getBookmarkById(username);
      apiRes = apiRes.sort(function (a, b) { return new Date(b.added_on).getTime() - new Date(a.added_on).getTime() })
      this.setState({
        apiResponse: apiRes,
        isLoaded: true
      })
    })
  }
  handleRename = (id, name, property) => {
    this.setState({
      showRenamePop: true,
      itemtoBeRenamedName: name,
      itemtoBeRenamedID: id,
      itemtoBeRenamedSearch: property
    })
  }
  handleRenameClose = (status) => {
    this.setState({
      showRenamePop: status,
      isLoaded: false
    }, async () => {
      let username = JSON.parse(localStorage.getItem('username')).toLowerCase()
      let service = new ApiServices();
      let apiRes = await service.getBookmarkById(username);
      apiRes = apiRes.sort(function (a, b) { return new Date(b.added_on).getTime() - new Date(a.added_on).getTime() })
      this.setState({
        apiResponse: apiRes,
        isLoaded: true
      })
    })
  }
  handelAddBookmark = () => {
    let params = new URLSearchParams(this.state.searchQuery)
    let query = params.get('query');
    let filter = params.get('filter');
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem('companyname'),
      `Create Bookmark`,
      "",
      window.location.href,
      query,
      filter
    );
  }
  render() {
    const { confirmMessageContent, confirmMessageShowModal } = this.state;
    if (this.props.customWidth < 600) {
      return (
        <Modal
          show={this.props.showModal}
          size="lg md sm xs"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="popup-transition-mob-tab"
          scrollable={true}
        >
          <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
            <div>
              <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                <div style={{ textAlign: "center", width: "100%" }}>
                  <Modal.Title>
                    <div className="actionItem-headerPart-mobile">
                      {this.props.isfromUserProfile ? (
                        <>
                          <div className="alert-active-features-button">
                            <span>View/Manage Bookmarks</span>
                          </div>
                        </>) : (
                        <>
                          <div onClick={e => { this.setState({ isCreateBookmark: true, isManage: false }) }} className={this.state.isCreateBookmark ? "alert-active-features-button" : "alert-features-buttons"}>
                            <span>Create Bookmark</span>
                          </div>
                          <div className="action-button-saperation-line"></div>
                          <div onClick={this.handleViewManageBookmark} className={this.state.isManage ? "alert-active-features-button" : "alert-features-buttons"}>
                            <span>View/Manage Bookmarks</span>
                          </div>
                        </>
                      )}
                    </div>
                  </Modal.Title>
                </div>
              </Modal.Header>
              <Modal.Body scrollable={true} style={{ maxHeight: "60vh" }}>
                {this.state.isCreateBookmark &&
                  (
                    this.state.isContinue ?
                      <>
                        <span className="noAlertText-mobile">Your bookmark has been saved successfully.</span>
                        <br />
                        <span className="saved-bookmark-text-mobile">Please go to 'View/Manage Bookmarks' tab to view all your saved ones.</span>
                      </>
                      :
                      <div>
                        <span className="create-bookmark-field">Give a name to your bookmark:</span>
                        <br />
                        <input type="text" placeholder="Type here" value={this.state.bookmarkName} className="create-bookmark-input-box" onChange={this.handleInput} />
                        <br />
                        <span className="length-info">Name with a maximum of 100 characters.</span>
                        <div className="errorInvalidName">{this.state.error["bookmarkName"]}</div>
                      </div>
                  )
                }
                {this.state.isManage &&
                  <div>
                    {this.state.isLoaded ? <>
                      {this.state.apiResponse.length > 0 ?
                        <span>
                          <table className="reading-list-view-wrapper">
                            <tr>
                              <th style={{ color: "#333", fontSize: "14.5px" }}>Bookmark Name</th>
                              <th style={{ textAlign: "center", color: "#333", fontSize: "14.5px" }}>Actions</th>
                            </tr>
                            <tbody>
                              {this.state.apiResponse.map((item, index) => {
                                return (<tr key={item.bookmark_id}>
                                  <td>{item.bookmark_name}</td>
                                  <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%", flexDirection: "column" }}><span onClick={() => this.viewBookmark(index)} title="View" className="reading-list-action-text">View</span><span title="Share" className="reading-list-action-text" onClick={() => this.shareBookmark(index)}>Share</span><span title="Rename" className="reading-list-action-text" onClick={e => this.handleRename(item.bookmark_id, item.bookmark_name, item.search_property)}>Rename</span><span onClick={e => this.deleteBookmark(index)} title="Delete" className="reading-list-action-text">Delete</span></td>
                                </tr>)
                              })}
                            </tbody>
                          </table>
                        </span>
                        : <><span className="noAlertText-mobile">No Bookmarks.</span>
                          <br />
                          <span className="no-bookmark-text-mobile">It looks like you don't have any bookmarks yet. To create a bookmark, please run a search and click on 'Bookmark' icon from the results screen.</span>
                        </>}
                    </> :
                      <div style={{ textAlign: "center", padding: "10%" }}>
                        <img src={imsLoader} alt="Loading Data" style={{ width: "10%" }} />
                      </div>
                    }
                  </div>
                }
                {/* {this.state.isManage &&
                  <div>
                    {this.state.isLoaded ? <>
                      {this.state.apiResponse.length > 0 ?
                        <span>
                          <table className="reading-list-view-wrapper">
                            <tr>
                              <th style={{ color: "#333", fontSize: "14.5px" }}>Bookmark Name</th>
                              <th style={{ textAlign: "center", color: "#333", fontSize: "14.5px" }}>Actions</th>
                            </tr>
                            <tbody>
                              {this.state.apiResponse.map((item, index) => {
                                return (<tr key={item.bookmark_id}>
                                  <td>{item.bookmark_name}</td>
                                  <td className="actionItems-td-mobile">
                                    <div className="actionItems-mobile">
                                      <span onClick={() => this.viewBookmark(index)} title="View" className="reading-list-action-text">View</span>
                                      <span title="Share" className="reading-list-action-text" onClick={() => this.shareBookmark(index)}>Share</span>
                                    </div>
                                    <div className="actionItems-mobile">
                                      <span title="Rename" className="reading-list-action-text" onClick={e => this.handleRename(item.bookmark_id, item.bookmark_name, item.search_property)}>Rename</span>
                                      <span onClick={e => this.deleteBookmark(index)} title="Delete" className="reading-list-action-text">Delete</span>
                                    </div>
                                  </td>
                                </tr>)
                              })}
                            </tbody>
                          </table>
                        </span>
                        : <><span className="noAlertText-mobile">No Bookmarks.</span>
                          <br />
                          <span className="no-bookmark-text-mobile">It looks like you don't have any bookmarks yet. To create a bookmark, please run a search and click on 'Bookmark' icon from the results screen.</span>
                        </>}
                    </> :
                      <div style={{ textAlign: "center", padding: "10%" }}>
                        <img src={imsLoader} alt="Loading Data" style={{ width: "10%" }} />
                      </div>
                    }
                  </div>
                } */}
              </Modal.Body>
              {this.state.isCreateBookmark ?
                this.state.isContinue ?
                  <div className="reading-list-button-wrapper-mobile">
                    <MobileViewButton text="Close" customColor="#000000" action={() => {
                      this.setState({ showPop: false });
                      this.props.handleClose(false);
                    }} />
                  </div>
                  :
                  <div className="gsf-popup-button-wrapper-mobile">
                    <div className="welcomeNxtBtn-mobile">
                      <MobileViewButton text="Save my bookmark" customColor="#EB1700" action={this.onSaveBookmark} />
                    </div>
                    {/* } */}
                    <div className="welcomeNxtBtn-mobile">
                      <MobileViewButton text="Cancel" customColor="#000000" action={() => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }} />
                    </div>

                  </div>
                :
                <div className="reading-list-button-wrapper-mobile">
                  <div className="welcomeNxtBtn-mobile">
                    <MobileViewButton text="Close" customColor="#000000" action={() => {
                      this.setState({ showPop: false });
                      this.props.handleClose(false);
                    }} />
                  </div>
                </div>
              }
            </div>
          </div>
          {this.state.showRenamePop &&
            <>
              <RenameBookmarkPopup showModal={this.state.showRenamePop} handleClose={(status) => this.handleRenameClose(status)} bookmarkName={this.state.itemtoBeRenamedName} bookmarkId={this.state.itemtoBeRenamedID} searchProperty={this.state.itemtoBeRenamedSearch} apiResponse={this.state.apiResponse} customWidth={this.props.customWidth} />
              <div className="savemodal-outer-wrapper"></div>
            </>
          }
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeAlertMessage()} handleConfirm={() => this.confirmHandler()} />}
        </Modal>
      );
    }
    else if (this.props.customWidth < 1000) {
      return (
        <Modal
          show={this.props.showModal}
          size="lg md sm xs"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="popup-transition-mob-tab"
          scrollable={true}
        >
          <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
            <div>
              <Modal.Header className="gsfModalHeader" style={{ justifyContent: "center" }}>
                <div style={{ textAlign: "center", width: "100%", paddingTop: "1%" }}>
                  <Modal.Title>
                    <div className="actionItem-headerPart">
                      {this.props.isfromUserProfile ? (
                        <>
                          <div className="alert-active-features-button">
                            <span>View/Manage Bookmarks</span>
                          </div>
                        </>) : (
                        <>
                          <div onClick={e => { this.setState({ isCreateBookmark: true, isManage: false }) }} className={this.state.isCreateBookmark ? "alert-active-features-button" : "alert-features-buttons"}>
                            <span>Create Bookmark</span>
                          </div>
                          <div className="action-button-saperation-line"></div>
                          <div onClick={this.handleViewManageBookmark} className={this.state.isManage ? "alert-active-features-button" : "alert-features-buttons"}>
                            <span>View/Manage Bookmarks</span>
                          </div>
                        </>
                      )}
                    </div>
                  </Modal.Title>
                </div>
              </Modal.Header>
              <Modal.Body scrollable={true} style={{ maxHeight: "40vh" }}>
                {this.state.isCreateBookmark &&
                  (
                    this.state.isContinue ?
                      <>
                        <span className="noAlertText-mobile">Your bookmark has been saved successfully.</span>
                        <br />
                        <span className="saved-bookmark-text-mobile">Please go to 'View/Manage Bookmarks' tab to view all your saved ones.</span>
                      </>
                      :
                      <div>
                        <span className="create-bookmark-field">Give a name to your bookmark:</span>
                        <br />
                        <input type="text" placeholder="Type here" value={this.state.bookmarkName} className="create-bookmark-input-box" onChange={this.handleInput} />
                        <br />
                        <span className="length-info">Name with a maximum of 100 characters.</span>
                        <div className="errorInvalidName">{this.state.error["bookmarkName"]}</div>
                      </div>
                  )
                }
                {this.state.isManage &&
                  <div>
                    {this.state.isLoaded ? <>
                      {this.state.apiResponse.length > 0 ?
                        <span>
                          <table className="manage-personal-alerts-wrapper">
                            <tr>
                              <th style={{ width: "20%" }}>Bookmark Name</th>
                              {/* <th style={{ width: "20%", textAlign: "center" }} >Alert Frequency</th> */}
                              <th style={{ width: "20%", textAlign: "center" }}>Date Saved</th>
                              <th style={{ width: "20%", textAlign: "center" }}>Actions</th>
                            </tr>
                            <tbody>
                              {this.state.apiResponse.map((item, index) => {
                                return (
                                  <tr key={item.bookmark_id}>
                                    <td>{item.bookmark_name}</td>
                                    <td style={{ textAlign: "center" }}>{moment(item.added_on).format("D-MMM-YYYY")}</td>
                                    <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}><span onClick={() => this.viewBookmark(index)} title="View" className="reading-list-action-text">View</span><span className="action-items-separate-divider"></span><span title="Share" className="reading-list-action-text" onClick={() => this.shareBookmark(index)}>Share</span><span className="action-items-separate-divider"></span><span title="Rename" className="reading-list-action-text" onClick={e => this.handleRename(item.bookmark_id, item.bookmark_name, item.search_property)}>Rename</span><span className="action-items-separate-divider"></span><span onClick={e => this.deleteBookmark(index)} title="Delete" className="reading-list-action-text">Delete</span></td>
                                  </tr>)
                              })}
                            </tbody>
                          </table>
                        </span>
                        : <><span className="noAlertText-mobile">No Bookmarks.</span>
                          <br />
                          <span className="no-bookmark-text-mobile">It looks like you don't have any bookmarks yet. To create a bookmark, please run a search and click on 'Bookmark' icon from the results screen.</span>
                        </>}
                    </> :
                      <div style={{ textAlign: "center", padding: "10%" }}>
                        <img src={imsLoader} alt="Loading Data" style={{ width: "10%" }} />
                      </div>
                    }
                  </div>
                }
              </Modal.Body>
              {this.state.isCreateBookmark ?
                this.state.isContinue ?
                  <div className="reading-list-button-wrapper-tablet">
                    <Button text="Close" customColor="#000000" action={() => {
                      this.setState({ showPop: false });
                      this.props.handleClose(false);
                    }} />
                  </div>
                  :
                  <div className="gsf-popup-button-wrapper-tablet">
                    <div className="welcomeNxtBtn">
                      <Button text="Cancel" customColor="#000000" action={() => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }} />
                    </div>
                    <div className="welcomeNxtBtn">
                      <Button text="Save my bookmark" customColor="#EB1700" action={this.onSaveBookmark} />
                    </div>
                  </div>
                :
                <div className="reading-list-button-wrapper-tablet">
                  <Button text="Close" customColor="#000000" action={() => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }} />
                </div>
              }
            </div>
          </div>
          {this.state.showRenamePop &&
            <>
              <RenameBookmarkPopup showModal={this.state.showRenamePop} handleClose={(status) => this.handleRenameClose(status)} bookmarkName={this.state.itemtoBeRenamedName} bookmarkId={this.state.itemtoBeRenamedID} searchProperty={this.state.itemtoBeRenamedSearch} apiResponse={this.state.apiResponse} customWidth={this.props.customWidth} />
              <div className="savemodal-outer-wrapper"></div>
            </>
          }
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeAlertMessage()} handleConfirm={() => this.confirmHandler()} />}
        </Modal>
      );
    }
    else {
      return (
        <Modal
          show={this.props.showModal}
          size="lg md sm xs"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="popup-transition"
          scrollable={true}
        >
          <div className="gen-ai-common-popup">
            <div className="gen-ai-common-popup__top-row">
              <div className="gen-ai-common-popup__tabs">
                {this.props.isfromUserProfile ? (<button
                  onClick={this.handleViewManageBookmark}
                  className={`gen-ai-common-popup__tab ${this.state.isfromUserProfile ? "gen-ai-common-popup__tab--active" : ""}`}>
                  View/Manage Bookmarks</button>) : (<>
                    <button
                      onClick={e => { this.setState({ isCreateBookmark: true, isManage: false }) }}
                      className={`gen-ai-common-popup__tab ${this.state.isCreateBookmark ? "gen-ai-common-popup__tab--active" : ""}`}>
                      Create Bookmark</button>
                    <button
                      onClick={this.handleViewManageBookmark}
                      className={`gen-ai-common-popup__tab ${this.state.isManage ? "gen-ai-common-popup__tab--active" : ""}`}>
                      View/Manage Bookmarks</button>
                  </>)}
              </div>

              <div className="gen-ai-common-popup__icon-area" onClick={e => {
                this.setState({ showPop: false });
                this.props.handleClose(false);
              }} aria-hidden="true">
                <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div className="gen-ai-common-popup__body">
              {this.state.isCreateBookmark &&
                (
                  this.state.isContinue ?
                    <>
                      <span className="no-bookmark-heading">Your bookmark has been saved successfully.</span>
                      <br />
                      <span className="no-bookmark-text">Please go to 'View/Manage Bookmarks' tab to view all your saved ones.</span>
                    </>
                    :
                    <div>
                      <span className="create-bookmark-field">Give a name to your bookmark:</span>
                      <br />
                      <input type="text" placeholder="Type here" value={this.state.bookmarkName} className="create-bookmark-input-box" onChange={this.handleInput} />
                      <br />
                      <span className="length-info">Name with a maximum of 100 characters.</span>
                      <div className="errorInvalidName">{this.state.error["bookmarkName"]}</div>
                    </div>
                )
              }
              {this.state.isManage &&
                <div>
                  {this.state.isLoaded ? <>
                    {this.state.apiResponse.length > 0 ?
                      <div className="gen-ai-common-popup__inner">
                        <div className="gen-ai-common-popup__header-row" role="row">
                          <div className="gen-ai-common-popup__header gen-ai-common-popup__header--name">Bookmark Name</div>
                          <div className="gen-ai-common-popup__header gen-ai-common-popup__header--date">Date Saved</div>
                          <div className="gen-ai-common-popup__header gen-ai-common-popup__header--actions" aria-hidden>
                            Actions
                          </div>
                        </div>
                        <ul className="gen-ai-common-popup__list" role="list">
                          {this.state.apiResponse.map((item, index) => {
                            return (
                              <li className="gen-ai-common-popup__row" key={item.bookmark_id} role="listitem">

                                <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--name">
                                  <span className="gen-ai-common-popup__link-name">{item.bookmark_name}</span>
                                </div>
                                <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--date">
                                  <span className="gen-ai-common-popup__date">{moment(item.added_on).format("D-MMM-YYYY")}</span>
                                </div>
                                <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--actions">
                                  <div className="gen-ai-common-popup__actions">
                                    <button
                                      type="button"
                                      className="gen-ai-common-popup__icon-btn"
                                      title="View"
                                      onClick={() => this.viewBookmark(index)}>
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1683_4216)">
                                          <path d="M1.61341 8.47537C1.52262 8.33161 1.47723 8.25973 1.45182 8.14886C1.43273 8.06559 1.43273 7.93425 1.45182 7.85097C1.47723 7.74011 1.52262 7.66823 1.61341 7.52447C2.36365 6.33648 4.59682 3.33325 8.00004 3.33325C11.4033 3.33325 13.6364 6.33648 14.3867 7.52447C14.4775 7.66823 14.5228 7.74011 14.5483 7.85097C14.5673 7.93425 14.5673 8.06559 14.5483 8.14886C14.5228 8.25973 14.4775 8.33161 14.3867 8.47537C13.6364 9.66336 11.4033 12.6666 8.00004 12.6666C4.59682 12.6666 2.36365 9.66336 1.61341 8.47537Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M8.00004 9.99992C9.10457 9.99992 9.99997 9.10449 9.99997 7.99992C9.99997 6.89535 9.10457 5.99992 8.00004 5.99992C6.89551 5.99992 6.00011 6.89535 6.00011 7.99992C6.00011 9.10449 6.89551 9.99992 8.00004 9.99992Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_1683_4216">
                                            <rect width="15.9994" height="16" rx="4" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      className="gen-ai-common-popup__icon-btn"
                                      aria-label={`More actions for ${item.search_name}`}
                                      onClick={() => this.shareBookmark(index)}
                                      title="Share">
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.8605 8.40489C14.0232 8.26539 14.1046 8.19564 14.1344 8.11264C14.1606 8.03979 14.1606 7.96011 14.1344 7.88726C14.1046 7.80426 14.0232 7.73451 13.8605 7.59501L8.21354 2.7546C7.93339 2.51447 7.79332 2.3944 7.67473 2.39146C7.57167 2.3889 7.47322 2.43418 7.40809 2.5141C7.33315 2.60606 7.33315 2.79055 7.33315 3.15953V6.02304C5.91008 6.27201 4.60764 6.99312 3.63975 8.07586C2.58453 9.25629 2.00082 10.7839 2 12.3673V12.7753C2.69954 11.9325 3.57295 11.251 4.56042 10.7772C5.43101 10.3596 6.37212 10.1122 7.33315 10.047V12.8404C7.33315 13.2093 7.33315 13.3938 7.40809 13.4858C7.47322 13.5657 7.57167 13.611 7.67473 13.6084C7.79332 13.6055 7.93339 13.4854 8.21354 13.2453L13.8605 8.40489Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      className="gen-ai-common-popup__icon-btn"
                                      onClick={e => this.handleRename(item.bookmark_id, item.bookmark_name, item.search_property)}
                                      title="Rename">
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1761_5055)">
                                          <path d="M1.91725 12.0771C1.94788 11.8014 1.96319 11.6636 2.0049 11.5347C2.0419 11.4205 2.09417 11.3117 2.16031 11.2114C2.23485 11.0983 2.33291 11.0003 2.52902 10.8042L11.3329 1.99998C12.0693 1.2636 13.2631 1.2636 13.9995 1.99998C14.7358 2.73636 14.7358 3.93027 13.9995 4.66665L5.19559 13.4708C4.99948 13.6669 4.90142 13.765 4.78838 13.8396C4.68809 13.9057 4.57932 13.958 4.46503 13.995C4.33621 14.0367 4.19838 14.052 3.92273 14.0826L1.66656 14.3333L1.91725 12.0771Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_1761_5055">
                                            <rect width="15.9994" height="16" rx="4" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      title="Delete"
                                      className="gen-ai-common-popup__icon-btn"
                                      aria-label={`Delete ${item.search_name}`}
                                      onClick={e => this.deleteBookmark(index)}>
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.6664 3.99992V3.46659C10.6664 2.71985 10.6664 2.34648 10.521 2.06126C10.3932 1.81038 10.1892 1.60641 9.93837 1.47858C9.65317 1.33325 9.27981 1.33325 8.5331 1.33325H7.46647C6.71976 1.33325 6.34641 1.33325 6.0612 1.47858C5.81033 1.60641 5.60636 1.81038 5.47854 2.06126C5.33322 2.34648 5.33322 2.71985 5.33322 3.46659V3.99992M2 3.99992H13.9996M12.6663 3.99992V11.4666C12.6663 12.5867 12.6663 13.1467 12.4483 13.5746C12.2566 13.9509 11.9506 14.2569 11.5743 14.4486C11.1465 14.6666 10.5865 14.6666 9.4664 14.6666H6.53317C5.41311 14.6666 4.85308 14.6666 4.42527 14.4486C4.04896 14.2569 3.74301 13.9509 3.55127 13.5746C3.33329 13.1467 3.33329 12.5867 3.33329 11.4666V3.99992" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                      : <div className="gen-ai-common-popup__inner">
                        <span className="no-bookmark-heading">No Bookmarks.</span>
                        <br />
                        <span className="no-bookmark-text">It looks like you don't have any bookmarks yet. To create a bookmark, please run a search and click on 'Bookmark' icon from the results screen.</span>
                      </div>}
                  </> :
                    <div style={{ textAlign: "center", padding: "10%" }}>
                      <img src={imsLoader} alt="Loading Data" style={{ width: "10%" }} />
                    </div>
                  }
                </div>
              }
            </div>

            {this.state.isCreateBookmark ?
              this.state.isContinue ?
                <div className="gen-ai-common-popup__footer">
                  <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline"
                    onClick={() => {
                      this.setState({ showPop: false });
                      this.props.handleClose(false);
                    }}>
                    Close
                  </button>
                </div>
                :
                <div className="gen-ai-common-popup__footer">
                  <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline" onClick={() => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }}>
                    Cancel
                  </button>
                  <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--primary"
                    onClick={this.onSaveBookmark}>
                    Save my bookmark
                  </button>
                </div>
              :
              <div className="gen-ai-common-popup__footer">
                <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline" onClick={() => {
                  this.setState({ showPop: false });
                  this.props.handleClose(false);
                }}>
                  Close
                </button>
              </div>
            }
          </div>
          {this.state.showRenamePop &&
            <>
              <GenAIRenameBookmarkPopUp showModal={this.state.showRenamePop} handleClose={(status) => this.handleRenameClose(status)} bookmarkName={this.state.itemtoBeRenamedName} bookmarkId={this.state.itemtoBeRenamedID} searchProperty={this.state.itemtoBeRenamedSearch} apiResponse={this.state.apiResponse} customWidth={this.props.customWidth} />
              <div className="savemodal-outer-wrapper"></div>
            </>
          }
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeAlertMessage()} handleConfirm={() => this.confirmHandler()} />}
        </Modal>
      );
    }
  }
}
export default GenAIBookmarkpopUp;
